import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"

export const getAvailablePlugins = async (entId) => {
    try {
        const url = `${apiRoutes.general.getAvailablePlugins}/${entId}`
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw error
    }
}

